<template>
  <AppNotifications />
  <Header v-if="!($route.name === 'Home')" />
  <div v-if="isHomePage"><router-view /></div>
  <div v-else class="main-container"><router-view /></div>
  <Footer />
</template>
<script>
import AppNotifications from '@/shared/components/layout/AppNotifications'
import Header from '@/shared/components/layout/Header'
import Footer from '@/shared/components/layout/Footer'
import { mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    Header, Footer, AppNotifications
  },
  computed: {
    isHomePage() {
      return this.$route.name === 'Home' || this.$route.name === 'Login' || this.$route.name === 'LoginSelection' || this.$route.name === 'SignupSelection'
    }
  },
  methods: {
    ...mapActions(['openAlertModal']),
  },
  async beforeCreate() {
    if (window.localStorage && window.localStorage.vuex) {
      const vuexData = JSON.parse(window.localStorage.vuex)
      if (vuexData && vuexData.auth && vuexData.auth.isUserLoggedIn) {
        this.$store.dispatch('userLoggedInFromVuex', vuexData.auth)
      }
    }
    await this.$store.dispatch('validateAuthToken')
    if (this.$store.getters.getUserAuthInfo.role === 'freelancer') await this.$store.dispatch('checkProfileStatus')
  }
}
</script>
